function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6257 8.8C12.2249 8.8 12.7523 8.472 13.024 7.976L15.8844 2.784C15.9518 2.66274 15.9863 2.52598 15.9847 2.38724C15.983 2.24851 15.9452 2.11262 15.875 1.99301C15.8047 1.8734 15.7045 1.77422 15.5843 1.70529C15.464 1.63636 15.3279 1.60007 15.1893 1.6H3.36386L2.61278 0H0V1.6H1.59803L4.47449 7.672L3.39582 9.624C2.81253 10.696 3.57959 12 4.79409 12H14.3823V10.4H4.79409L5.67301 8.8H11.6257ZM4.12292 3.2H13.831L11.6257 7.2H6.01659L4.12292 3.2ZM4.79409 12.8C3.91518 12.8 3.20405 13.52 3.20405 14.4C3.20405 15.28 3.91518 16 4.79409 16C5.67301 16 6.39212 15.28 6.39212 14.4C6.39212 13.52 5.67301 12.8 4.79409 12.8ZM12.7842 12.8C11.9053 12.8 11.1942 13.52 11.1942 14.4C11.1942 15.28 11.9053 16 12.7842 16C13.6632 16 14.3823 15.28 14.3823 14.4C14.3823 13.52 13.6632 12.8 12.7842 12.8Z",
  fill: "#666666"
});
function SvgIconCartLineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartLineGray);
export default __webpack_public_path__ + "static/media/iconCartLineGray.8df0a9a4.svg";
export { ForwardRef as ReactComponent };